import { Fragment, useState, useEffect } from "react";
import { notification, Button } from "antd";
import { TitleHeader, Searcher, TableAntd } from "../../components";
import { ReloadOutlined } from "@ant-design/icons";
import { Redirect } from "react-router-dom";
import { useAuth } from "../../utils/useAuth";
import { executeQuery } from "../../api/sistema";
import { createColumns } from "./formatTable";

function Registrador() {
  const { isAdmin } = useAuth();
  const [filterTable, setFilterTable] = useState(null);
  const [page, setPage] = useState(1);

  const [dataToTable, setDataToTable] = useState([]);
  const [reload, setReload] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const fetchDataToTable = async () => {
    setIsLoading(true);

    executeQuery({
      query: "get_all_registradores",
      collection: "ope_registrador"
    })
      .then((res) => {
        setDataToTable(res.payload);
      })
      .catch((err) => {
        notification.error({
          message: "Problemas con la solicitud",
          description: err.message
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchDataToTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  if (!isAdmin) return <Redirect to="/app" />;

  const columnsToTable = createColumns(page);

  const search = (value) => {
    const tempFilterTable = dataToTable.filter((o) =>
      Object.keys(o).some((k) => String(o[k]).toLowerCase().includes(value.toLowerCase()))
    );

    setFilterTable(tempFilterTable);
  };

  return (
    <Fragment>
      <TitleHeader
        title={
          <span className="flex gap-2 items-center">
            <h1 className="font-bold">Registradores ({dataToTable.length})</h1>
            <Button
              size="small"
              icon={<ReloadOutlined />}
              onClick={() => setReload(!reload)}
            ></Button>
          </span>
        }
        // extra={
        //   <div className="flex gap-2 flex-col flex-wrap  md:flex-row md:flex-nowrap">
        //     <Upload
        //       showUploadList={false}
        //       {...uploadProps({
        //         name: "mas_archivo",
        //         action: "/app/upload",
        //         makeReload: () => setReload(!reload)
        //       })}
        //       accept=".xlsx"
        //     >
        //       <Button icon={<FileExcelOutlined />}>Importar</Button>
        //     </Upload>
        //   </div>
        // }
      />

      <Searcher onSearch={search} placeholder="Busca algún usuario" />

      <TableAntd
        columns={columnsToTable}
        dataSource={filterTable == null ? dataToTable : filterTable}
        setPage={setPage}
        isLoading={isLoading}
      />
    </Fragment>
  );
}

export default Registrador;
